export const environment = {
    production: true,
    apiUrl: 'https://api.sport.masak.preprod-s4.cawita.com',
    assetUrl: 'https://assets.sport.masak.preprod-s4.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR'
};
